/**
 * Parses a search query string, extracting quoted phrases and individual words.
 *
 * @param query - The search query string to parse
 * @param options - Optional configuration
 * @param options.lowercase - Whether to convert terms to lowercase (default: false)
 * @returns Array of search terms, where quoted phrases are kept together
 *
 * @example
 * parseSearchQuery('vitamin "t score" wrist')
 * // => ['vitamin', 't score', 'wrist']
 *
 * @example
 * parseSearchQuery('VITAMIN "T Score" WRIST', { lowercase: true })
 * // => ['vitamin', 't score', 'wrist']
 */
export function parseSearchQuery(query: string, options: { lowercase?: boolean } = {}): string[] {
  const terms: string[] = [];
  const regex = /"([^"]+)"|(\S+)/g;
  let match;

  while ((match = regex.exec(query)) !== null) {
    // match[1] is quoted content, match[2] is non-quoted word
    const term = match[1] ?? match[2];
    if (term) {
      const normalizedTerm = options.lowercase ? term.toLowerCase().trim() : term.trim();
      if (normalizedTerm.length > 0) {
        terms.push(normalizedTerm);
      }
    }
  }

  return terms;
}
